let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("60ISK")).then(() => parcelRequire('8OVUQ'));